module.exports = {"upload_list":"Upload List","name":"Name","progress":"Progress","size":"Size","time":"Time","cancel":"Cancel","complete":"Complete","uploading":"Uploading","queue_limit_warn":"Please add less than {0} files once","canceled":"Canceled","in_the_queue":"In the queue"}


//////////////////
// WEBPACK FOOTER
// ./src/language/en-us.json
// module id = s+TF
// module chunks = 0 1